export default function IconLogoutAndError(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (980 / 444.841) : 980}
      height={height ? height : width ? width * (444.841 / 980) : 444.841}
      viewBox="0 0 980 444.841"
    >
      <g>
        <g fill="#2c0313">
          <path d="M49.604 72.77h130.041a6.459 6.459 0 0 0 0-12.918H49.604a6.459 6.459 0 0 0 0 12.918Z" />
          <path d="M49.604 115.424h130.041a6.459 6.459 0 1 0 0-12.918H49.604a6.459 6.459 0 0 0 0 12.918Z" />
          <path d="M349.466 104.222 248.88 3.622a6.449 6.449 0 0 0-4.564-1.9H31.002a29.326 29.326 0 0 0-29.28 29.311v382.774a29.326 29.326 0 0 0 29.28 29.315h291.079a29.326 29.326 0 0 0 29.28-29.311V108.795a6.777 6.777 0 0 0-1.895-4.569Zm-98.691-80.43 78.453 78.537H261.54a10.774 10.774 0 0 1-10.765-10.776V23.792Zm87.668 390.015a16.364 16.364 0 0 1-16.362 16.38H31.002a16.364 16.364 0 0 1-16.362-16.38V31.033a16.364 16.364 0 0 1 16.362-16.379h206.855v76.9a23.682 23.682 0 0 0 23.682 23.708h76.9Z" />
          <path d="M31 0h213.317a8.121 8.121 0 0 1 5.783 2.4l100.626 100.651a8.455 8.455 0 0 1 2.358 5.746v305.008a31.054 31.054 0 0 1-31 31.035H31a31.054 31.054 0 0 1-31-31.035V31.035A31.054 31.054 0 0 1 31 0Zm317.226 105.423L247.663 4.84a4.7 4.7 0 0 0-3.347-1.392H31A27.6 27.6 0 0 0 3.445 31.035v382.77A27.6 27.6 0 0 0 31 441.392h291.081a27.6 27.6 0 0 0 27.558-27.587V108.8a5.086 5.086 0 0 0-1.413-3.377ZM31 12.931h208.58v78.623a21.936 21.936 0 0 0 21.96 21.983h78.626v300.268a18.07 18.07 0 0 1-18.085 18.1H31a18.081 18.081 0 0 1-18.085-18.1V31.035A18.07 18.07 0 0 1 31 12.931Zm205.135 3.449H31a14.641 14.641 0 0 0-14.64 14.656v382.77A14.641 14.641 0 0 0 31 428.461h291.081a14.641 14.641 0 0 0 14.64-14.656V116.986H261.54a25.4 25.4 0 0 1-25.4-25.432Zm12.918 3.251 84.334 84.424H261.54a12.508 12.508 0 0 1-12.487-12.5Zm76.018 80.975L252.5 27.956v63.6a9.057 9.057 0 0 0 9.042 9.052Z" />
        </g>
        <g>
          <path
            fill="#2c0313"
            d="M887.682 412.52h-83.707a8.612 8.612 0 1 1 0-17.224h83.707a19.312 19.312 0 0 0 19.29-19.29v-27.9a8.612 8.612 0 0 1 17.224 0v27.9a36.555 36.555 0 0 1-36.514 36.514Z"
          />
          <path
            fill="#2c0313"
            d="M915.584 133.023a8.612 8.612 0 0 1-8.612-8.612v-27.9a19.312 19.312 0 0 0-19.29-19.29h-83.707a8.612 8.612 0 1 1 0-17.224h83.707a36.555 36.555 0 0 1 36.514 36.514v27.9a8.612 8.612 0 0 1-8.612 8.612Z"
          />
          <path
            fill="#2c0313"
            d="M734.406 440.415a22.352 22.352 0 0 1-3.629-.3l-167.192-23.054a22.688 22.688 0 0 1-19.341-22.6V68.117a22.538 22.538 0 0 1 17.75-21.83L729.181 4.996a22.98 22.98 0 0 1 5.038-.573 22.574 22.574 0 0 1 22.563 22.505v391.09a22.388 22.388 0 0 1-22.377 22.4Zm-.182-418.746a5.344 5.344 0 0 0-1.139.123L565.893 63.08a5.4 5.4 0 0 0-4.427 5.184v326.29a5.389 5.389 0 0 0 4.558 5.442l167.326 23.078 1.057.1a5.156 5.156 0 0 0 5.153-5.158V26.964a5.342 5.342 0 0 0-5.336-5.295Z"
          />
          <path
            fill="#2c0313"
            d="M971.388 244.849H817.926a8.612 8.612 0 1 1 0-17.224h132.671l-41.1-41.1a8.612 8.612 0 1 1 12.176-12.182l55.8 55.8a8.612 8.612 0 0 1-6.089 14.7Z"
          />
          <path
            fill="#73042d"
            d="M971.388 244.849H817.926a8.612 8.612 0 1 1 0-17.224h132.671l-41.1-41.1a8.612 8.612 0 1 1 12.176-12.182l55.8 55.8a8.612 8.612 0 0 1-6.089 14.7Z"
          />
          <path
            fill="#2c0313"
            d="M915.584 300.726a8.612 8.612 0 0 1-6.089-14.7l55.8-55.8a8.612 8.612 0 0 1 12.183 12.173l-55.8 55.8a8.585 8.585 0 0 1-6.094 2.527Z"
          />
          <path
            fill="#73042d"
            d="M915.584 300.726a8.612 8.612 0 0 1-6.089-14.7l55.8-55.8a8.612 8.612 0 0 1 12.183 12.173l-55.8 55.8a8.585 8.585 0 0 1-6.094 2.527Z"
          />
          <path
            fill="#2c0313"
            d="M676.094 237.315a15.587 15.587 0 0 1 0-31.175v13.951Z"
          />
          <path
            fill="#2c0313"
            d="M676.09 237.315V206.14a15.587 15.587 0 1 1 0 31.175Z"
          />
        </g>
        <g>
          <path
            fill="#73042d"
            d="M173.053 376.322a108.813 108.813 0 1 1 108.813-108.811 108.937 108.937 0 0 1-108.813 108.811Zm0-99.238 32.754 32.753a6.77 6.77 0 1 0 9.574-9.573l-32.753-32.755 32.751-32.753a6.77 6.77 0 0 0-9.574-9.576l-32.754 32.756-32.754-32.755a6.771 6.771 0 0 0-9.575 9.576l32.755 32.752-32.754 32.755a6.77 6.77 0 0 0 9.575 9.573l32.753-32.753Z"
          />
        </g>
      </g>
    </svg>
  );
}
